<form [formGroup]="directDebitForm" (yatSubmit)="submitForm($event)">
  <div class="row">
    <div class="col-12">
      <div class="form-group">
        <label for="account-owner">{{ 'checkout.paymentInformation.directDebitForm.accountOwner.label' | transloco }}</label>
        <input
          type="text"
          class="form-control"
          id="account-owner"
          formControlName="accountOwner"
          placeholder="{{ 'checkout.paymentInformation.directDebitForm.accountOwner.placeholder' | transloco }}"
          maxlength="60"
          yatAutoFocus
          yatInput />
        <div class="invalid-feedback" [ngSwitch]="directDebitForm.controls.accountOwner.errors | classifyValidationError">
          <span *ngSwitchCase="'required'">{{ 'checkout.paymentInformation.directDebitForm.accountOwner.validators.required' | transloco }}</span>
          <span *ngSwitchCase="'accountOwner'">{{ 'checkout.paymentInformation.directDebitForm.accountOwner.validators.accountOwner' | transloco }}</span>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="form-group mb-2">
        <label for="iban">{{ 'checkout.paymentInformation.directDebitForm.iban.label' | transloco }}</label>
        <input
          #iban
          autocomplete="off"
          type="text"
          class="form-control"
          id="iban"
          formControlName="iban"
          mask="SS00 AAAA AAAA AAAA AAAA AAAA AAAA AAAA AA"
          [dropSpecialCharacters]="false"
          [validation]="false"
          (input)="iban.value = iban.value.toUpperCase()"
          yatInput />
        <div class="invalid-feedback" [ngSwitch]="directDebitForm.controls.iban.errors | classifyValidationError">
          <span *ngSwitchCase="'required'">{{ 'checkout.paymentInformation.directDebitForm.iban.validators.required' | transloco }}</span>
          <span *ngSwitchCase="'iban'">{{ 'checkout.paymentInformation.directDebitForm.iban.validators.iban' | transloco }}</span>
          <span *ngSwitchCase="'sepa'">{{ 'checkout.paymentInformation.directDebitForm.iban.validators.sepa' | transloco }}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="mb-3 c-gray" [ngSwitch]="ibanDetailsStatus">
    <ng-container *ngSwitchCase="'empty'">
      <p class="font-small ls-01 mb-0">{{ 'checkout.paymentInformation.directDebitForm.ibanDetails.enterYourIban' | transloco }}</p>
    </ng-container>
    <ng-container *ngSwitchCase="'loaded'">
      <div class="row">
        <div class="col-6 pr-0 clip-text">
          {{ this.directDebitForm.controls.bank.value || ('checkout.paymentInformation.directDebitForm.ibanDetails.unknownBank' | transloco) }}
        </div>
        <div class="col-6 text-right">
          {{
            (directDebitForm.controls.bic.value !== null
              ? 'checkout.paymentInformation.directDebitForm.ibanDetails.bic'
              : 'checkout.paymentInformation.directDebitForm.ibanDetails.unknownBic'
            ) | transloco: { bic: directDebitForm.controls.bic.value }
          }}
        </div>
      </div>
    </ng-container>
  </div>
  <div class="row">
    <div class="col-12 c-gray mb-2">
      <transloco id="d530c542-df20-47b8-954d-d75c9458d858" key="checkout.paymentInformation.directDebitForm.sepaDirectDebitAuthorizationText"></transloco>
    </div>
  </div>
  <yat-buttons
    [primaryButtonName]="('saveAndContinue' | commonWording | async) ?? ''"
    [secondaryButtonName]="('back' | commonWording | async) ?? ''"
    (secondaryButtonClickMethod)="cancel()"
    [asyncForm]="directDebitForm"
    [className]="buttonsClassName"
    [matomoEventCategory]="MATOMO_EVENT_CATEGORY_PAYMENT"
    matomoEventClickPrimaryButtonAction="Confirm_PaymentMethodForm"
    matomoEventClickSecondaryButtonAction="Cancel_PaymentMethodForm"
    matomoEventName="DirectDebit">
  </yat-buttons>
</form>
